module.exports = __webpack_public_path__ + "static/media/continental@3x.b4ba473f.png";